/**
 * Every clickable item on the home page describes *what* it does with an
 * action object instead of an inline handler. `useHomeAction` resolves them.
 *
 *   { type: ACTION_TYPES.ROUTE, to: '/courses' }
 *   { type: ACTION_TYPES.CREATE_COURSE }
 *   { type: ACTION_TYPES.OPEN_PORTAL }
 *   { type: ACTION_TYPES.EXTERNAL, href: 'https://...' }
 *   { type: ACTION_TYPES.INTERCOM_ARTICLE, articleId: '123' }
 *   { type: ACTION_TYPES.INTERCOM_SPACE, space: 'help' }
 *   { type: ACTION_TYPES.INTERCOM_MESSAGES }
 */
export const ACTION_TYPES = {
  ROUTE: 'route',
  CREATE_COURSE: 'create_course',
  OPEN_PORTAL: 'open_portal',
  EXTERNAL: 'external',
  INTERCOM_ARTICLE: 'intercom_article',
  INTERCOM_SPACE: 'intercom_space',
  INTERCOM_MESSAGES: 'intercom_messages',
}

/**
 * Single source of truth for where home page items navigate.
 * Update a destination here when its dedicated page ships.
 */
export const HOME_ROUTES = {
  BRANDING: '/workspace/branding',
  CONNECT_AI: '/connect',
  // TODO: People (no page yet); learners are invited per learning path.
  INVITE_LEARNERS: '/collections',
  INVITE_TEAM: '/workspace/members',
  LEARNING_PATH: '/collections',
  CUSTOM_DOMAIN: '/workspace/custom-domain',
  INTEGRATIONS: '/workspace/integrations',
  CERTIFICATES: '/collections',
}
